module.exports = __webpack_public_path__ + "static/media/Angenommen.031cfcd7.svg";